import { useEffect, useState } from "react";
import { database } from "../firebase/FirebaseConfig";
import { ref, push, serverTimestamp } from "firebase/database";
import { getUserData } from "../Hooks/getUserData";

// Cookies get Functions
const getCookie = (name) => {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

// Function to set cookies
const setCookie = (clickID, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  if (window.location.hostname === "localhost") {
    document.cookie = `DFS=${clickID}${expires}; path=/`;
  } else {
    document.cookie = `DFS=${clickID}${expires}; path=/; domain=.franzspitzer.de; Secure; SameSite=None`;
  }
};

// Save to firebase success (ASYNC)
const saveToDatabase = async (userData, clickID = null) => {
  try {
    const dataRef = ref(database, `clicks`);
    const newEntry = await push(dataRef, {
      ...userData,
      clickID: clickID,
      timestamp: serverTimestamp(),
    });
    return newEntry.key;
  } catch (error) {
    console.error("❌ Error to save in Firebase:", error);
    throw error;
  }
};

// SaveData Component
const SaveData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await getUserData();
      setUserData(data);
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    if (!userData) return;

    /*
    const getLastUrlParameter = () => {
      const url = window.location.href;
      const parts = url.split("/");
      return parts[parts.length - 1];
    };*/

    const getLastUrlParameter = () => {
      const url = window.location.href;

      // Split the URL into parts using "/" and take the last segment without query parameters
      const parts = url.split("/");
      const lastPath = parts[parts.length - 1].split("?")[0]; // Last path without query parameters

      // Extract query parameters using URLSearchParams
      const searchParams = new URLSearchParams(window.location.search);

      // Convert query parameters into an object
      const paramsObject = {};
      searchParams.forEach((value, key) => {
        paramsObject[key] = value;
      });

      return {
        campaignID: lastPath || "", // The last part of the URL path
        queryParamsObject: paramsObject || {}, // Query parameters as a JavaScript object
        queryParamsString: window.location.search.substring(1) || "", // Query parameters as a string (including "?")
      };
    };

    const campaign = getLastUrlParameter();
    let campaignID = campaign.campaignID;

    const source = {
      f: "Facebook",
      r: "Rumble",
      i: "Instagram",
      y: "YouTube",
      t: "TikTok",
      d: "Direct",
      g: "Google Ads",
      n: "Newsletter",
      x: "X (Twitter)",
      o: "Other",
      a: "App Store",
      p: "Playstore",
      s: "Snapchat",
      w: "Website",
      e: "Email",
      l: "LinkedIn",
      k: "Gesundheitscheck",
      u: "Gefahrenanalyse",
    };

    const sourceType = {
      v: "Paid",
      l: "Organic",
    };

    let targets = {};
    if (window.location.hostname === "localhost") {
      targets = {
        a: "https://www.franzspitzer.de/uber-mich",
        b: "https://natugena.de/shop/Weihrauch-800.aspx?r=19570", // Weihrauch
        c: "https://www.franzspitzer.de/coaching",
        d: "https://natugena.de/artikeldetails/Hanf-Aromaextrakt-Gold-10.aspx?r=19570", // CBD-Öl
        e: "https://natugena.de/shop/TendoDyn.aspx?r=19570", // TendoDyn
        f: "https://tierarzt.franzspitzer.de/start",
        g: "https://tierarzt.franzspitzer.de/termin-buchung", // Terminbuchung
        h: "https://www.franzspitzer.de",
        i: "https://natugena.de/shop/Alle-Produkte/MikroVeda-LIFE.aspx?r=19570", // MikroVeda Life
        j: "https://jobs.franzspitzer.de",
        k: "https://natugena.de/shop/anwendungen/bewegung-gelenke/Kollagen.aspx?r=19570", // Kollagen
        l: "https://tierarzt.franzspitzer.de/",
        m: "https://natugena.de/shop/MonoDiTox.aspx?r=19570", // MonoDiTox
        n: "https://natugena.de/shop/N-Zymarase-Intest.aspx?r=19570", // N-Zymerase intest
        o: "https://natugena.de/shop/Omega-3-Vegane-Kapseln.aspx?r=19570", // Omega 3 (Alge)
        p: "https://buch.franzspitzer.de", // Book
        q: "https://natugena.de/shop/Carnitin-Q10.aspx?r=19570", // Carnitin&Q10
        r: "https://www.franzspitzer.de/bewertungen",
        s: "https://natugena.de/shop/Omega-3-Kapseln.aspx?r=19570", // Omega 3 (Lachs)
        u: "https://natugena.de/artikeldetails/Mumijo.aspx?r=19570", // Mumijo
        w: "http://localhost:5173/der-weg-zum-gesunden-hund",
        x: "https://natugena.de/shop/Astaxanthin.aspx?r=19570", // Astaxanthin
        y: "https://natugena.de/shop/Taurin-2000.aspx?r=19570", // Taurin
        z: "https://natugena.de/shop/klinopur-Zeolith-Detox-Pulver.aspx?r=19570", // Zeolith
        1: "http://localhost:5173/gesundheitscheck",
        2: "http://localhost:5173/gefahrenanalyse",
      };
    } else {
      targets = {
        a: "https://www.franzspitzer.de/uber-mich",
        b: "https://natugena.de/shop/Weihrauch-800.aspx?r=19570", // Weihrauch
        c: "https://www.franzspitzer.de/coaching",
        d: "https://natugena.de/artikeldetails/Hanf-Aromaextrakt-Gold-10.aspx?r=19570", // CBD-Öl
        e: "https://natugena.de/shop/TendoDyn.aspx?r=19570", // TendoDyn
        f: "https://tierarzt.franzspitzer.de/start",
        g: "https://tierarzt.franzspitzer.de/termin-buchung", // Terminbuchung
        h: "https://www.franzspitzer.de",
        i: "https://natugena.de/shop/Alle-Produkte/MikroVeda-LIFE.aspx?r=19570", // MikroVeda Life
        j: "https://jobs.franzspitzer.de",
        k: "https://natugena.de/shop/anwendungen/bewegung-gelenke/Kollagen.aspx?r=19570", // Kollagen
        l: "https://tierarzt.franzspitzer.de/",
        m: "https://natugena.de/shop/MonoDiTox.aspx?r=19570", // MonoDiTox
        n: "https://natugena.de/shop/N-Zymarase-Intest.aspx?r=19570", // N-Zymerase intest
        o: "https://natugena.de/shop/Omega-3-Vegane-Kapseln.aspx?r=19570", // Omega 3 (Alge)
        p: "https://buch.franzspitzer.de", // Book
        q: "https://natugena.de/shop/Carnitin-Q10.aspx?r=19570", // Carnitin&Q10
        r: "https://www.franzspitzer.de/bewertungen",
        s: "https://natugena.de/shop/Omega-3-Kapseln.aspx?r=19570", // Omega 3 (Lachs)
        v: "https://tierarzt.franzspitzer.de/die-verborgene-wahrheit-der-tiermedizin", // Tiermedizin Buch
        u: "https://natugena.de/artikeldetails/Mumijo.aspx?r=19570", // Mumijo
        w: "https://tierarzt.franzspitzer.de/der-weg-zum-gesunden-hund",
        x: "https://natugena.de/shop/Astaxanthin.aspx?r=19570", // Astaxanthin
        y: "https://natugena.de/shop/Taurin-2000.aspx?r=19570", // Taurin
        z: "https://natugena.de/shop/klinopur-Zeolith-Detox-Pulver.aspx?r=19570", // Zeolith
        1: "https://kurse.franzspitzer.de/gesundheitscheck",
        2: "https://kurse.franzspitzer.de/gefahrenanalyse",
      };
    }

    let targetKey = campaignID[0]?.toLowerCase() || "";
    let target =
      targets[targetKey] ||
      "https://tierarzt.franzspitzer.de/der-weg-zum-gesunden-hund";

    if (targetKey === "t") {
      const randomTarget = Math.random() < 0.25 ? "l" : "w";
      targetKey = randomTarget;
      target = targets[randomTarget];
      campaignID = randomTarget + campaignID.slice(1);
      campaign.campaignID = campaignID;
      campaign.campaignFull = campaignID;
    }

    const sourceKey = campaignID[1]?.toLowerCase() || "";
    const sourceValue = source[sourceKey] || "Unknown";
    const sourceTypeKey = campaignID[2]?.toLowerCase() || "";
    const sourceTypeValue = sourceType[sourceTypeKey] || "Unknown";

    const clickID = getCookie("DFS");

    const saveAndRedirect = async () => {
      try {
        const key = await saveToDatabase(
          {
            ...userData,
            campaign: campaignID.substring(2),
            campaignFull: campaignID,
            params: { ...campaign.queryParamsObject },
            source: sourceValue,
            target: target,
            type: sourceTypeValue,
          },
          clickID
        );
        setCookie(key, 30);
        window.location.href = `${target}${
          target.includes("?") ? "&" : "?"
        }id=${key}&${campaign.queryParamsString}`;
      } catch (error) {
        console.error("❌ Error save data:", error);
        window.location.href = target;
      }
    };

    saveAndRedirect();
  }, [userData]);

  return (
    <div className="a">
      <div className="b" />
      <p className="c">wird geladen...</p>
    </div>
  );
};

export default SaveData;
